<template>
  <div class="cmp-royalty-contracts-contracts_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="search">
        <!-- Handled in Mixin -->
        <InputField
          :value="basicFilter.searchString"
          :placeholder="'Search'"
          :config="{
            borderStyle: 'bottom',
            maxWidth: '200px',
            minWidth: '200px',
            width: '200px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
      </div>
      <div class="right-container ut-colcen">
        <button class="dt-button v5 s8" @click="onRunAutoFetchClicked">
          {{ $t("run_auto_fetch_all_contracts") }}
        </button>
      </div>
    </div>
    <div class="dt-page--body">
      <NTable
        id="royalty-contracts-contracts_list"
        class="h1"
        :config="tableConfig"
        :headers="headers"
        :items="list"
        @scrollnext="onListScroll"
        :loadingFlag="loadingFlag"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr
            :class="{
              selected: selectedRow(item),
            }"
            @click="onContractsClicked(item)"
            :title="'Click to see Contracts List'"
          >
            <td v-bind="tdcon('contracts')">
              <div class="ut-flex">
                <DtStatus
                  :statusTVList="statusTV"
                  :item="getItemForStatus(item)"
                  @updateStatus="e => onStatusChange(e, item)"
                />
                <div
                  class="txtov"
                  :title="item['contract_name']"
                  style="font-weight: bold; margin-left: 4px"
                >
                  <b> {{ item["contract_name"] }}</b>
                </div>
              </div>
            </td>
            <td v-bind="tdcon('royalty_account')">
              <span class="txtov" :title="item['royalty_account_name']">{{
                item["royalty_account_name"]
              }}</span>
            </td>
            <td v-bind="tdcon('total_releases')">
              <span class="txtov" :title="item['total_releases']">{{
                item["total_releases"]
              }}</span>
            </td>
            <td v-bind="tdcon('products')">
              <span class="txtov" :title="item['total_products']">{{
                item["total_products"]
              }}</span>
            </td>
            <td v-bind="tdcon('tracks')">
              <span class="txtov" :title="item['total_tracks']">{{
                item["total_tracks"]
              }}</span>
            </td>
            <td v-bind="tdcon('royalty_types')">
              <div
                v-if="item['mechanical_flag'] == 1"
                style="display: flex; margin: 0 auto"
              >
                <img
                  src="static/icons/royalty/mechanical-contract.svg"
                  class="dt-icon v5 s2"
                  alt="Mechanical"
                  title="Mechanical"
                  :style="{
                    opacity: item['shorter_royalty_types']
                      ? item['shorter_royalty_types'].split(',').includes('dig')
                        ? '1'
                        : '0.2'
                      : '0.2',
                  }"
                />
              </div>
              <div v-else style="display: flex">
                <img
                  src="static/icons/royalty/icon-digital.svg"
                  class="dt-icon v5 s2"
                  alt="Digital"
                  title="Digital"
                  :style="{
                    opacity: item['shorter_royalty_types']
                      ? item['shorter_royalty_types'].split(',').includes('dig')
                        ? '1'
                        : '0.2'
                      : '0.2',
                  }"
                />

                <img
                  src="static/icons/royalty/icon-physical.svg"
                  class="dt-icon v5 s2"
                  alt="Physical"
                  title="Physical"
                  :style="{
                    opacity: item['shorter_royalty_types']
                      ? item['shorter_royalty_types'].split(',').includes('phy')
                        ? '1'
                        : '0.2'
                      : '0.2',
                  }"
                />

                <img
                  src="static/icons/royalty/icon-thirdparty.svg"
                  class="dt-icon v5 s2"
                  alt="Third Party"
                  title="Third Party"
                  :style="{
                    opacity: item['shorter_royalty_types']
                      ? item['shorter_royalty_types'].split(',').includes('thi')
                        ? '1'
                        : '0.2'
                      : '0.2',
                  }"
                />

                <img
                  src="static/icons/royalty/icon-licensing.svg"
                  class="dt-icon v5 s2"
                  alt="Licensing"
                  title="Licensing"
                  :style="{
                    opacity: item['shorter_royalty_types']
                      ? item['shorter_royalty_types'].split(',').includes('lic')
                        ? '1'
                        : '0.2'
                      : '0.2',
                  }"
                />

                <img
                  src="static/icons/royalty/icon-performance.svg"
                  class="dt-icon v5 s2"
                  alt="Performance"
                  title="Performance"
                  :style="{
                    opacity: item['shorter_royalty_types']
                      ? item['shorter_royalty_types'].split(',').includes('per')
                        ? '1'
                        : '0.2'
                      : '0.2',
                  }"
                />
              </div>
            </td>
            <td v-bind="tdcon('cross_collect')">
              <div class="ut-rowcen">
                <div class="dt-checkbox v2 s1 disabled2">
                  <input
                    type="checkbox"
                    :name="'cross_collectable'"
                    :id="'cross_collectable'"
                    :checked="item['cross_collectable'] == '1'"
                    :disabled="true"
                  />
                  <div class="checkmark"></div>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </NTable>
    </div>

    <DtPageStatusFloat :statusTV="statusTV" />

    <Sidewindow
      :navConfig="defaultConfig"
      :value="contractsDetailsFlag"
      @closed="onCloseContractsDetails"
    >
      <ContractsSidewindow />
    </Sidewindow>
  </div>
</template>

<script>
import InputField from "@plugins/text-field/input-field";
import NTable from "@/plugins/datatable/datatable";
import * as ActionTypes from "../../store/types";
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { contractsRoyaltyGetters } from "../../store/contracts/getters";
import { contractsRoyaltyActions } from "../../store/contracts/actions";
import {
  getContractsDetailsSelectable,
  royaltyContractsListLDTRoutes,
} from "../../router/routes";
import {
  childOfOrEqualDetails,
  handleFromRoute,
} from "../../../../utility/route";
import {
  createLDTHost,
  defaultConfig,
} from "../../../../dt-plugins/sidewindow";
import { getInvoiceStatusColor } from "../../../accounting/models/color-status";

import ContractsSidewindow from "./contracts-sidewindow";
import { async } from "rxjs/internal/scheduler/async";
import { ContractsService } from "../../services/contracts.service";
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import { forEach } from "ramda";
import DtPageStatus from "@dtplugins/dtpage-status/dtpage-status";
import DtPageStatusFloat from "@dtplugins/dtpage-status/dtpage-status-float";
import DtStatus from "@dtplugins/dt-status-dropdown/dt-status";
import { createTV, createTVI } from "../../../../models/text-value.model";
const LDTConfig = {
  entityName: "contract",
  ldtRoutes: royaltyContractsListLDTRoutes,
  detailsSelectableFunction: getContractsDetailsSelectable,
  primaryKey: "contract_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.ContractsDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.ContractsDetails.FETCH.SINGLE,
};

export default {
  components: {
    InputField,
    NTable,
    DtPageStatus,
    ContractsSidewindow,
    DtPageStatusFloat,
    DtStatus,
  },
  data: function () {
    return {
      selectedClickedContract: null,
      defaultConfig: defaultConfig,
      getContractsDetailsSelectable: getContractsDetailsSelectable,

      getInvoiceStatusColor: getInvoiceStatusColor,
    };
  },
  mixins: [
    createFetchListMixin(ActionTypes.ContractsList.FETCH.ALL, 50, {
      advancedSearchable: false,
      searchable: true,
      scrollable: true,
    }),
    createLDTHost(LDTConfig),
  ],
  async mounted() {
    const res = await ContractsService.fetchContractDetailsTabInfo(0);
    const payload = {
      ...res.data,
    };
    this[ActionTypes.ContractsFlagDetails.SET.ALL](payload);
  },
  computed: {
    ...mapGetterObject(storeNS, contractsRoyaltyGetters),

    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      });
    },
    list: function () {
      console.log("list ", this.contractsList?.contracts || []);
      return this.contractsList?.contracts || [];
    },
    statusTVList: function () {
      return (
        this.contractsList?.label_statuses?.map((e) => {
          return {
            text: e["label_status_name"],
            value: e["label_status_colour"],
            id: e["label_status_id"],
          };
        }) || []
      );
    },
    statusTV: function () {
      return (
        createTVI(
          this.contractsList?.label_statuses,
          "label_status_name",
          "label_status_colour",
          "label_status_id",
          true,
        ) || []
      );
    },
    headers: () => [
      createTableHeader("contracts", { fw: 700 }),
      // createTableHeader("contract_ref", { f: 0.8, fw: 700 }),
      createTableHeader("royalty_account", { fw: 700 }),
      createTableHeader("total_releases", { mw: 65, ta: "center" }),
      createTableHeader("products", { mw: 65, ta: "center" }),
      createTableHeader("tracks", { mw: 65, ta: "center" }),
      createTableHeader("royalty_types", { mw: 164, ta: "center" }),
      createTableHeader("cross_collect", { mw: 110, ta: "center" }),
    ],
    filter: function () {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter,
      };
    },
    statuses: function () {
      return (
        createTV(
          this.contractsList?.label_statuses || [],
          "label_status_name",
          "label_status_colour"
        ) || []
      );
    },
    contractsDetailsFlag: function () {
      return childOfOrEqualDetails(royaltyContractsListLDTRoutes, this.$route);
    },
  },
  methods: {
    ...mapActionObject(storeNS, contractsRoyaltyActions),
    getItemForStatus: function (item) {
      return {
        itemID: item.contract_id,
        colorPropertyName: "label_status_id",
        colorPropertyValue: item.label_status_id,
        colorName: "label_status_colour",
        colorValue: this.statusTV?.find((x) => x.id === item.label_status_id)
          ?.value,
      };
    },
    selectedRow: function (contract) {
      return (
        this.selectedClickedContract &&
        this.selectedClickedContract["contract_id"] == contract["contract_id"]
      );
    },

    onRunAutoFetchClicked: async function () {
      const confirmationResult = await ConfirmationService.createP({
        subject: "You will be notified when the process is complete.",
        results: [{ text: "OK", classes: "v1", value: "ok" }],
      });

      if (confirmationResult) {
        const runAutoRes = await ContractsService.autoFetchForAllContracts();
      }
    },

    defaultBasicFilter() {
      return {
        searchString: "",
        artist: undefined,
        digital_right: undefined,
        isrc_check: false,
      };
    },

    // Start Sidewindow
    onContractsClicked: async function (contract) {
      console.log(":::::::::::", contract);
      this.selectedClickedContract = contract;
      this.$router.push({
        name: royaltyContractsListLDTRoutes.names.tab,
        params: {
          contract_id: contract.contract_id,
          tab: "overview",
        },
      });
    },
    onCloseContractsDetails: function () {
      this.selectedClickedContract = null;
      handleFromRoute(this, () => {
        this.$router.push({
          name: royaltyContractsListLDTRoutes.names.list,
        });
      });
    },
    onStatusChange: function (payload, contract) {
      console.log({'contracts-list.vue:404 item' : contract});
      //const item = this.selectedReleaseDetails;
      // this[ActionTypes.ContractsList.UPDATE.SINGLE](payload);
      //console.log(payload,payload)

      const {
        itemID,
        colorPropertyValue,
      } = payload;


      // Use Singular Action for All Updates - to Simplify


      this[ActionTypes.ContractsDetails.UPDATE.SINGLE]({
        selectedContractDetails: {
          contract: {
            contract_id: itemID,
            ...contract
          }
        },
        name: 'label_status_id',
        value: colorPropertyValue,
      });

    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-contracts-contracts_list {
  .dt-page--body {
    --offset: 160px;
  }
  .contract-list-footer {
    border-top: 1px solid var(--sprt-5);
    padding: 0 10px;

    .status-list {
      .status {
        margin-top: 15px;
        max-width: 110px;
      }
    }
  }
}

.status-list {
  // flex: 1;
  display: flex;
}
.status {
  //flex: 1;
  display: flex;
  align-items: center;
  max-width: 150px;
  .circle-status {
    margin-right: 10px;
  }
  .status-name {
    flex: 1;
  }
}
</style>
